import { withQuery } from "utils/helpers"

namespace AdminUrls {
  export const home = "/"

  export const discover = "/discover"
  export const myLessons = "/my-lessons"

  export function lessons(args?: {
    grade?: string
    subject?: string
    search?: string
  }): string {
    return withQuery("/lessons", args)
  }

  export const viewLessonTemplate = "/view/:id"

  export function viewLesson(id: string) {
    return `/view/${id}`
  }

  export const printLessonTemplate = "/print/:id"
  export function printLesson(id: string) {
    return `/print/${id}`
  }

  export const printPreviewLessonTemplate = "/print-preview/:id"
  export function printPreviewLesson(id: string) {
    return `/print-preview/${id}`
  }

  export const createLesson = "/create-lesson"

  export const uploadEnvles = "/upload-envles"

  export const editLessonTemplate = "/edit/:lessonId/:screenId?"
  export const editLesson = (
    lessonId: string,
    selectedScreenId?: string | null
  ) => {
    let url = `/edit/${lessonId}`
    if (selectedScreenId) {
      url += `/${selectedScreenId}`
    }
    return url
  }
  export const createClass = "/classes/create"
  export const editClassTemplate = "/classes/:id"
  export const editClass = (classId: string) => `/classes/${classId}`
  export const listClasses = "/classes"

  /** The class list with its search box filled in; the query lives in the URL, as on the lessons page. */
  export function listClassesSearch(search: string): string {
    return withQuery(listClasses, { search })
  }

  export const viewStudentReportsTemplate =
    "/classes/:classId/student/:studentId"
  export const viewStudentReports = (classId: string, studentId: string) =>
    `/classes/${classId}/student/${studentId}`

  export const viewStudentReportTemplate =
    "/classes/:classId/student/:studentId/report/:reportId"
  export const viewStudentReport = (
    classId: string,
    studentId: string,
    reportId: string
  ) => `/classes/${classId}/student/${studentId}/report/${reportId}`

  export const createClassroomTemplate = "/classroom/create/:id"
  export const createClassroom = ({ lessonId }: { lessonId: string }) =>
    `/classroom/create/${lessonId}`

  export const createSingleSeatModeTemplate = "/single-seat-mode/create/:id"
  export const createSingleSeatMode = ({ lessonId }: { lessonId: string }) =>
    `/single-seat-mode/create/${lessonId}`

  export const createHomeworkTemplate = "/homework/create/:id"
  export const createHomework = ({ lessonId }: { lessonId: string }) =>
    `/homework/create/${lessonId}`
  export const listHomeworkTemplate = "/homework/:page?"
  export const listHomework = (params?: { page?: number }) => {
    if (!!params && typeof params.page === "number") {
      return `/homework/${params.page}`
    } else {
      return "/homework/"
    }
  }
  export const viewHomeworkTemplate = "/homework/:id/view"
  export const viewHomework = (sessionId: string) =>
    `/homework/${sessionId}/view`

  export const viewReportRedirectTemplate = "/report/:id"
  export const viewReportRedirect = (id: string) => `/report/${id}`
  export const viewReportByStudentTemplate = "/report/:id/by-student"
  export const viewReportByStudent = (id: string) => `/report/${id}/by-student`
  export const viewReportByScreensTemplate = "/report/:id/by-screen"
  export const viewReportByScreen = (id: string) => `/report/${id}/by-screen`

  export const listReportsTemplate = "/reports/:page?"
  export const listReports = (params?: { page?: number }) => {
    if (!!params && typeof params.page === "number") {
      return `/reports/${params.page}`
    } else {
      return `/reports/`
    }
  }

  export const viewProfile = "/profile"
  export const editProfile = "/profile/edit"
  export const viewSubscription = "/subscription"
  export const viewSubscriptionSuccessfulPayment =
    "/subscription/successful-payment"
  export const viewSubscriptionFailedPayment = "/subscription/failed-payment"

  export const helpCenter = "/help"
  export const helpArticleHowToStartLesson = "/help/articles/start-lesson"
  export const helpArticleHowToStartClassroomLesson = "/help/articles/start-classroom-lesson"
  export const helpArticleHowToCreateClass = "/help/articles/create-class"
  export const helpArticleHowToAssignHomework = "/help/articles/assign-homework"

  export const viewNvo = "/nvo"
  export const viewNvoClassTemplate = "/nvo/:id"
  export const viewNvoClass = (classId: string) => `/nvo/${classId}`

  export const viewOrg = "/org"
  export const viewOrgSettings = "/org/settings"
  export const viewOrgCertificates = "/org/certs"
  export const editOrgCertificateTemplate = "/org/certs/:id"
  export const editOrgCertificate = (certId: string) => `/org/certs/${certId}`
}

export default AdminUrls
